
(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['exports', 'echarts'], factory);
  } else if (typeof exports === 'object' && typeof exports.nodeName !== 'string') {
    // CommonJS
    factory(exports, require('echarts'));
  } else {
    // Browser globals
    factory({}, root.echarts);
  }
}(this, function (exports, echarts) {
  let log = function (msg) {
    if (typeof console !== 'undefined') {
      console && console.error && console.error(msg);
    }
  };
  if (!echarts) {
    log('ECharts is not Loaded');
    return;
  }
  echarts.registerTheme('espreport2', {
    "color": [
      "#FF8100FF",
      "#1DAB77FF",
      "#1976d2",
      "#DD2C00",
      "#c6b38e",
      "#a4d8c2",
      "#f3d999",
      "#d3758f"
    ],
    "backgroundColor": "rgba(0,0,0,0)",
    "textStyle": {},
    "title": {
      "textStyle": {
        "color": "#424242"
      },
      "subtextStyle": {
        "color": "#aaaaaa"
      }
    },
    "line": {
      "itemStyle": {
        "borderWidth": 1
      },
      "lineStyle": {
        "width": 2
      },
      "symbolSize": 4,
      "symbol": "emptyCircle",
      "smooth": false
    },
    "radar": {
      "itemStyle": {
        "borderWidth": 1
      },
      "lineStyle": {
        "width": 2
      },
      "symbolSize": 4,
      "symbol": "emptyCircle",
      "smooth": false
    },
    "bar": {
      "itemStyle": {
        "barBorderWidth": 0,
        "barBorderColor": "#ccc"
      }
    },
    "pie": {
      "itemStyle": {
        "borderWidth": 0,
        "borderColor": "#ccc"
      }
    },
    "scatter": {
      "itemStyle": {
        "borderWidth": 0,
        "borderColor": "#ccc"
      }
    },
    "boxplot": {
      "itemStyle": {
        "borderWidth": 0,
        "borderColor": "#ccc"
      }
    },
    "parallel": {
      "itemStyle": {
        "borderWidth": 0,
        "borderColor": "#ccc"
      }
    },
    "sankey": {
      "itemStyle": {
        "borderWidth": 0,
        "borderColor": "#ccc"
      }
    },
    "funnel": {
      "itemStyle": {
        "borderWidth": 0,
        "borderColor": "#ccc"
      }
    },
    "gauge": {
      "itemStyle": {
        "borderWidth": 0,
        "borderColor": "#ccc"
      }
    },
    "candlestick": {
      "itemStyle": {
        "color": "#1D893A",
        "color0": "#424242",
        "borderColor": "#1D893A",
        "borderColor0": "#000000",
        "borderWidth": 1
      }
    },
    "graph": {
      "itemStyle": {
        "borderWidth": 0,
        "borderColor": "#ccc"
      },
      "lineStyle": {
        "width": 1,
        "color": "#aaaaaa"
      },
      "symbolSize": 4,
      "symbol": "emptyCircle",
      "smooth": false,
      "color": [
        "#1D893A",
        "#424242",
        "#1D893A",
        "#999999",
        "#4CAF50",
        "#000000",
        "#ffcdd2",
        "#eeeeee"
      ],
      "label": {
        "color": "#eeeeee"
      }
    },
    "map": {
      "emphasis": {
        "itemStyle": {
          "areaColor": "#e6b600",
          "borderColor": "#ddd",
          "borderWidth": 1
        },
        "label": {
          "color": "#1D893A"
        }
      },
      "itemStyle": {
        "normal": {
          "areaColor": "#ddd",
          "borderColor": "#eee",
          "borderWidth": 0.5
        },
      },
      "label": {
        "color": "#1D893A"
      }
    },
    "geo": {
      "itemStyle": {
        "areaColor": "#ddd",
        "borderColor": "#eee",
        "borderWidth": 0.5
      },
      "emphasis": {
        "textStyle": {
          "color": "#1D893A"
        },
        "itemStyle": {
          "areaColor": "#e6b600",
          "borderColor": "#ddd",
          "borderWidth": 1
        }
      },
      "label": {
        "color": "#1D893A"
      }
    },
    "categoryAxis": {
      "axisLine": {
        "show": true,
        "lineStyle": {
          "color": "#333"
        }
      },
      "axisTick": {
        "show": true,
        "lineStyle": {
          "color": "#333"
        }
      },
      "axisLabel": {
        "show": true,
        "color": "#333"
      },
      "splitLine": {
        "show": false,
        "lineStyle": {
          "color": [
            "#ccc"
          ]
        }
      },
      "splitArea": {
        "show": false,
        "areaStyle": {
          "color": [
            "rgba(250,250,250,0.3)",
            "rgba(200,200,200,0.3)"
          ]
        }
      }
    },
    "valueAxis": {
      "axisLine": {
        "show": true,
        "lineStyle": {
          "color": "#333"
        }
      },
      "axisTick": {
        "show": true,
        "lineStyle": {
          "color": "#333"
        }
      },
      "axisLabel": {
        "show": true,
        "color": "#333"
      },
      "splitLine": {
        "show": true,
        "lineStyle": {
          "color": [
            "#ccc"
          ]
        }
      },
      "splitArea": {
        "show": false,
        "areaStyle": {
          "color": [
            "rgba(250,250,250,0.3)",
            "rgba(200,200,200,0.3)"
          ]
        }
      }
    },
    "logAxis": {
      "axisLine": {
        "show": true,
        "lineStyle": {
          "color": "#333"
        }
      },
      "axisTick": {
        "show": true,
        "lineStyle": {
          "color": "#333"
        }
      },
      "axisLabel": {
        "show": true,
        "color": "#333"
      },
      "splitLine": {
        "show": true,
        "lineStyle": {
          "color": [
            "#ccc"
          ]
        }
      },
      "splitArea": {
        "show": false,
        "areaStyle": {
          "color": [
            "rgba(250,250,250,0.3)",
            "rgba(200,200,200,0.3)"
          ]
        }
      }
    },
    "timeAxis": {
      "axisLine": {
        "show": true,
        "lineStyle": {
          "color": "#333"
        }
      },
      "axisTick": {
        "show": true,
        "lineStyle": {
          "color": "#333"
        }
      },
      "axisLabel": {
        "show": true,
        "color": "#333"
      },
      "splitLine": {
        "show": true,
        "lineStyle": {
          "color": [
            "#ccc"
          ]
        }
      },
      "splitArea": {
        "show": false,
        "areaStyle": {
          "color": [
            "rgba(250,250,250,0.3)",
            "rgba(200,200,200,0.3)"
          ]
        }
      }
    },
    "toolbox": {
      "emphasis": {
        "iconStyle": {
          "borderColor": "#424242"
        }
      },
      "iconStyle": {
        "borderColor": "#000000"
      }
    },
    "legend": {
      "textStyle": {
        "color": "#333333"
      }
    },
    "tooltip": {
      "axisPointer": {
        "lineStyle": {
          "color": "#cccccc",
          "width": 1
        },
        "crossStyle": {
          "color": "#cccccc",
          "width": 1
        }
      }
    },
    "timeline": {
      "emphasis": {
        "itemStyle": {
          "color": "#1D893A"
        },
        "controlStyle": {
          "color": "#1D893A",
          "borderColor": "#1D893A",
          "borderWidth": 0.5
        },
        "label": {
          "color": "#1D893A"
        }
      },
      "lineStyle": {
        "color": "#1D893A",
        "width": 1
      },
      "itemStyle": {
        "color": "#1D893A",
        "borderWidth": 1
      },
      "controlStyle": {
        "color": "#1D893A",
        "borderColor": "#1D893A",
        "borderWidth": 0.5
      },
      "checkpointStyle": {
        "color": "#1D893A",
        "borderColor": "#1D893A"
      },
      "label": {
        "color": "#1D893A"
      }
    },
    "visualMap": {
      "color": [
        "#1D893A",
        "#4CAF50",
        "#FFC107",
        "#ffcdd2"
      ]
    },
    "dataZoom": {
      "backgroundColor": "rgba(47,69,84,0)",
      "dataBackgroundColor": "rgba(47,69,84,0.3)",
      "fillerColor": "rgba(167,183,204,0.4)",
      "handleColor": "#a7b7cc",
      "handleSize": "100%",
      "textStyle": {
        "color": "#333333"
      }
    },
    "markPoint": {
      "label": {
        "color": "#eeeeee"
      },
      "emphasis": {
        "label": {
          "color": "#eeeeee"
        }
      }
    }
  });
}));
